import Modal from '../..';
import Form from '../../../Form';
import useStore from '../../../Hooks/useStore';

const ModalValidityCreate = () => {
  const [getters, setters] = useStore();
  const {
    modal: { getModal },
  } = getters;
  const {
    modal: { closeSingleModal },
  } = setters;
  const isOpen = getModal('single.createValidity');
  const onClose = () => {
    closeSingleModal('createValidity');
  };
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      headerTitle="Nova validade"
      height={'auto'}
      width={'60vw'}
    >
      <Form.Validity.Validity.Create />
    </Modal>
  );
};

export default ModalValidityCreate;
